module.exports = __webpack_public_path__ + "img/cases-brand-chinamobile-lazyload-101.5eb9bbe7.jpg";